import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './ProgressIndicator.scss';

const indicatorPropTypes = {
    dark: PropTypes.bool,
    hidden: PropTypes.bool,
    items: PropTypes.array,
};

const indicatorDefaultProps = {
    dark: false,
    hidden: false,
    items: [],
};

const ProgressIndicator = ({ dark, hidden, items }) => {
    const classes = classNames({
        ProgressIndicator: true,
        'ProgressIndicator--dark': dark,
        'ProgressIndicator--hidden': hidden,
    });

    return (
        <ul className={classes}>
            {items?.map(({ name, ...rest }) => (
                <IndicatorItem key={name} {...rest} />
            ))}
        </ul>
    );
};

ProgressIndicator.propTypes = indicatorPropTypes;
ProgressIndicator.defaultProps = indicatorDefaultProps;

const indicatorItemPropTypes = {
    active: PropTypes.bool,
    disableProgress: PropTypes.bool,
    progress: PropTypes.number,
    visited: PropTypes.bool,
};

const indicatorItemDefaultProps = {
    active: false,
    disableProgress: false,
    progress: 0,
    visited: false,
};

const IndicatorItem = ({ active, disableProgress, progress, visited }) => {
    const itemClasses = classNames({
        ProgressIndicator__item: true,
        'ProgressIndicator__item--active': active,
        'ProgressIndicator__item--visited': visited && !active,
        'ProgressIndicator__item--no-progress': visited && disableProgress,
    });

    return <li className={itemClasses}>{active ? <span className="ProgressIndicator__item--active--progress" style={{ width: `${progress}%` }} /> : null}</li>;
};

IndicatorItem.propTypes = indicatorItemPropTypes;
IndicatorItem.defaultProps = indicatorItemDefaultProps;

export default ProgressIndicator;
